export default {
  zh: {
    idtitile: 'Distribution - to userID',
    noMore: 'No more records',
    more: 'More',
    distribution: 'Distribution - to userID',
    recharge: 'Recharge - to userID',
    overdraw: 'Overdraw - to userID',
    coin_transfer: '硬币转账记录'
  },
  en: {
    idtitile: 'Distribution - to userID',
    noMore: 'No more records',
    more: 'More',
    empText: 'Oops, no records yet.',
    distribution: 'Distribution - to userID',
    recharge: 'Recharge - to userID',
    overdraw: 'Overdraw - to userID',
    coin_transfer: 'Coins transfer record'
  },
  ar: {
    // 阿拉伯
    idtitile: 'التوزيع - إلى أيدي المستخدم',
    noMore: 'لا مزيد من السجلات',
    more: 'أكثر',
    empText: 'عفوًا، لا توجد سجلات حتى الآن.',
    distribution: 'التوزيع - إلى أيدي المستخدم',
    recharge: 'إعادة الشحن - إلى معرف المستخدم',
    overdraw: 'السحب الزائد - إلى معرف المستخدم',
    coin_transfer: 'سجل نقل العملات'
  },
  tr: {
    //土耳其
    idtitile: 'Dağıtım - kullanıcı ID',
    noMore: 'Başka kayıt yok',
    more: 'Daha',
    empText: 'Henüz kayıt yok.',
    distribution: 'Dağıtım - kullanıcı ID',
    recharge: 'Şarj edin - kullanıcı kimliğine',
    overdraw: 'Fazla çekme - kullanıcı kimliğine',
    coin_transfer: 'Coin transfer kaydı'
  },
  pt: {
    idtitile: 'Distribuição - para userID',
    noMore: 'Sem mais registros',
    more: 'Mais',
    empText: 'Ops, nenhum registro ainda.',
    distribution: 'Distribuição - para userID',
    recharge: 'Recarga - para userID',
    overdraw: 'Excesso - para userID',
    coin_transfer: 'Registro de transferência de moedas'
  },
  id: {
    idtitile: 'Distribusi - ke userID',
    noMore: 'Tidak ada lagi catatan',
    more: 'Lebih banyak',
    empText: 'Ups, belum ada catatan.',
    distribution: 'Distribusi - ke userID',
    recharge: 'Isi ulang - ke userID',
    overdraw: 'Penarikan lebih - ke userID',
    coin_transfer: 'Catatan transfer koin'
  },
  uz: {
    idtitile: 'Taqqsimlash - userID ga',
    noMore: "Boshqa yozuvlar yo'q",
    more: "Ko'proq",
    empText: 'Afsuski, hali hech qanday yozuv mavjud emas.',
    distribution: 'Taqqsimlash - userID ga',
    recharge: "To'ldirish - userID ga",
    overdraw: 'Hisobni oshirish - userID ga',
    coin_transfer: 'Tangalar transferi tarixi'
  },
  ru: {
    idtitile: 'Распределение - для userID',
    noMore: 'Нет больше записей',
    more: 'Больше',
    empText: 'Упс, пока нет записей.',
    distribution: 'Распределение - для userID',
    recharge: 'Пополнение - для userID',
    overdraw: 'Перерасход - для userID',
    coin_transfer: 'Запись перевода монет'
  },
  fa: {
    idtitile: 'توزیع - به userID',
    noMore: 'هیچ رکوردی بیشتر وجود ندارد',
    more: 'بیشتر',
    empText: 'اوپس، هنوز هیچ رکوردی وجود ندارد.',
    distribution: 'توزیع - به userID',
    recharge: 'شارژ - به userID',
    overdraw: 'برداشت اضافی - به userID',
    coin_transfer: 'سابقه انتقال سکه'
  },
  ur: {
    idtitile: 'تقسیم - صارف آئی ڈی کو',
    noMore: 'مزید ریکارڈز نہیں',
    more: 'مزید',
    empText: 'اوہ! ابھی تک کوئی ریکارڈ موجود نہیں',
    distribution: 'تقسیم - صارف آئی ڈی کو',
    recharge: 'ری چارج - صارف آئی ڈی کو',
    overdraw: 'اوور ڈرا - صارف آئی ڈی کو',
    coin_transfer: 'سکے منتقلی کا ریکارڈ'
  }
}



// WEBPACK FOOTER //
// src/pages/app/newGoldRecold/lang.js